import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useControles } from "../../../context/controles.context";
import { Deposit } from "../../../services/betfive";
import { PrimaryButton, PrimaryTextInput } from "../../../globalComponents";
import QRCode from 'qrcode.react';
import InputMask from 'react-input-mask';

import axios from 'axios'
import { MiniLoading } from "../../MiniLoading";
import LoadingMain from "../../Loadings/LoadingMain";
import { useWhitelabel } from "../../../context/whitelabel.context";
import playgreen from "../../../services/playgreen";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '15px 5px',
    maxWidth: '600px',
    width: '100%',
    height: '80%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--Secondary-Background)',
    borderRadius: '8px',
    gap: 2,
    
  };

const ModalDeposit = () => {
    const {open, setOpen, tituloModal, urlModal, openDeposit, setopenDeposit, setloadingDeposit, isMobile} = useControles();
    
    const {metodoDeposito, valorMinimoDeposito} = useWhitelabel()

    const handleOpen = () => setopenDeposit(true);
    const handleClose = () => setopenDeposit(false);

    const [objDeposit, setobjDeposit] = useState()
    const [valor, setvalor] = useState()
    const [errorDeposit, setErrorDeposit] = useState(false)

    const [imagemQRCODE, setimagemQRCODE] = useState()

    const [isLoading, setIsLoading] = useState(false)
    const [cpf, setCpf] = useState('')

    const {urlDepositar} = useWhitelabel()

    useEffect(() => {
        console.log("metodoDeposito", metodoDeposito)
    }, [])

    const fetchDeposit = async (valor) => {
        setIsLoading(true)
        if(valor < valorMinimoDeposito){
            setIsLoading(false)
            setErrorDeposit(`O valor mínimo para depósito é de R$ ${valorMinimoDeposito},00`)
            return
        }
        
        try {
            const response = await axios.post(metodoDeposito, {
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'PostmanRuntime/7.37.3',
                },
                valor: valor,
                bearerToken: localStorage.getItem('tokenPlaygreen'),
                document: cpf,
                user_id: JSON.parse(localStorage.getItem('loginObj')).results.user.id
            })

            console.log(response.data.results)

            setobjDeposit(response.data.results)
            setIsLoading(false)
            setErrorDeposit(false)
    
        }catch (error) {
            console.log(error)
            setIsLoading(false)
            setErrorDeposit("Erro ao gerar o pix.")
           
        }
        
    }

    useEffect(() => {
        const fetchData = async () => {
            if(objDeposit){
                // const response = await axios.get(objDeposit.qr_code_base64)
                // console.log(response, 'QR CODE')
                // const codigo64 = response.data
                // const imageUrl = `data:image/png;base64,${codigo64}`;
                setimagemQRCODE(objDeposit.qr_code_base64)
            }
        }
        
        fetchData()
    }, [objDeposit]);

    const copyQrCode = () => {
        // Verifica se o navegador suporta a API de Clipboard
        if (navigator.clipboard) {
            // Copia o valor de objDeposit.info.qr_code para a área de transferência
            navigator.clipboard.writeText(objDeposit.qr_code)
                .then(() => {
                    console.log('Texto copiado com sucesso!');
                })
                .catch(err => {
                    console.error('Erro ao copiar texto: ', err);
                });
        } else {
            // Fallback para navegadores que não suportam a API de Clipboard
            const textArea = document.createElement('textarea');
            textArea.value = objDeposit.info.qr_code;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                console.log('Texto copiado com sucesso!');
            } catch (err) {
                console.error('Erro ao copiar texto: ', err);
            }
            document.body.removeChild(textArea);
        }
    }
  
    return (
      <div style={{position: 'relative'}}>
        
        <Modal
          open={openDeposit}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <h2 style={{color: 'var(--Primary-color)', fontSize: '32px'}}>Depositar</h2>

            {!metodoDeposito || metodoDeposito.length < 3 ? 
                <iframe style={{width: '100%', height: '100%'}} src={urlDepositar}>

                </iframe>
                :
                <>
                <div style={{display: 'flex', flexDirection: 'column', gap: 20}}>
                    <span style={{color: 'white'}}>
                        Digite o valor que deseja depositar:
                    </span>
                    <PrimaryTextInput type="number" placeholder="0,00" value={valor} onChange={(e) => setvalor(e.target.value)} />
                    <InputMask
        mask="999.999.999-99"
        value={cpf}
        onChange={(e) => setCpf(e.target.value)}
      >
        {(inputProps) => (
          <PrimaryTextInput {...inputProps} type="text" placeholder="CPF" />
        )}
      </InputMask>
                  
                    <PrimaryButton style={{padding: 10}} onClick={() => {
                        fetchDeposit(valor)
                    }}>
                        Depositar
                    </PrimaryButton>
                    
                </div>
                
                </>
            }
            
            
            {objDeposit && imagemQRCODE &&

                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20}}>
                    <img src={imagemQRCODE} style={{width: '150px', height: '150px'}}/>

                    {/* <QRCode value={imagemQRCODE}/> */}

                    <PrimaryButton style={{padding: '10px 20px'}} onClick={() => {
                        copyQrCode()
                    }}>
                        Copiar Codigo
                    </PrimaryButton>

                    <span style={{color: 'white'}}>
                        (ao depositar, re-logue em sua conta para atualizar o saldo)
                    </span>
                </div>

                }

                {isLoading && <LoadingMain/>}

                {errorDeposit && 
                <span style={{color: 'var(--Primary-color)'}}>
                    {errorDeposit}
                </span>
                }
          
            
          </Box>
          
        </Modal>
        
      </div>
    )
}

export default ModalDeposit